import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { IconButton, Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import dayjs from "dayjs";

interface Props {
  data: any;
  brandName: string;
}

export default function DatacollectionLastRun({ data, brandName }: Props) {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  return (
    <div>
      <IconButton onClick={toggleDrawer(true)} color="secondary" sx={{ p: 1 }}>
        <EmojiObjectsOutlinedIcon color="secondary" />
      </IconButton>

      <Drawer
        sx={{ zIndex: 9999 }}
        open={open}
        anchor={"right"}
        onClose={toggleDrawer(false)}
      >
        <Box
          sx={{ width: 260 }}
          role="presentation"
          onClick={toggleDrawer(false)}
        >
          <Typography
            variant="h6"
            px={2}
            pt={1}
            color={"#000000DE"}
            mb={1}
            fontSize={"20px"}
            fontWeight={"500"}
          >
            Data Collection Last Run
          </Typography>

          <Paper
            sx={{ boxShadow: "none", overflowY: "auto", height: "90vh", p: 2 }}
          >
            <Stack>
              <Typography sx={{ fontSize: "16px" }} variant="body1">
                Brand Name
              </Typography>
              <Typography
                sx={{ color: "#7B1FA2", fontWeight: "500", fontSize: "18px" }}
                mb={2}
                variant="body1"
              >
                {brandName}
              </Typography>
            </Stack>
            <Stack>
              <Typography sx={{ fontSize: "16px" }} variant="body1">
                Brand ID
              </Typography>
              <Typography
                sx={{ color: "#7B1FA2", fontWeight: "500", fontSize: "18px" }}
                mb={2}
                variant="body1"
              >
                {data?.brand_id}
              </Typography>
            </Stack>
            <Stack>
              <Typography sx={{ fontSize: "16px" }} variant="body1">
                Run Date
              </Typography>
              <Typography
                sx={{ color: "#7B1FA2", fontWeight: "500", fontSize: "18px" }}
                mb={2}
                variant="body1"
              >
                {dayjs(data?.created)?.format("DD-MM-YYYY") as any}
              </Typography>
            </Stack>
            <Stack>
              <Typography sx={{ fontSize: "16px" }} variant="body1">
                Run Range
              </Typography>
              <Typography
                sx={{ color: "#7B1FA2", fontWeight: "500", fontSize: "18px" }}
                mb={2}
                variant="body1"
              >
                {dayjs(data?.from_date)?.format("DD-MM-YYYY") as any} -
                {dayjs(data?.to_date)?.format("DD-MM-YYYY") as any}
              </Typography>
            </Stack>
            <Stack>
              <Typography sx={{ fontSize: "16px" }} variant="body1">
                Run By
              </Typography>
              <Typography
                sx={{ color: "#7B1FA2", fontWeight: "500", fontSize: "18px" }}
                mb={2}
                variant="body1"
              >
                {data?.run_by}
              </Typography>
            </Stack>
            <Stack>
              <Typography sx={{ fontSize: "16px" }} variant="body1">
                Status
              </Typography>
              <Typography
                sx={{ color: "#7B1FA2", fontWeight: "500", fontSize: "18px" }}
                mb={2}
                variant="body1"
              >
                {data?.status}
              </Typography>
            </Stack>
          </Paper>
        </Box>
      </Drawer>
    </div>
  );
}
